import { datadogLogs } from '@datadog/browser-logs';
import { environmentLabels, getEnvironmentLabel } from './environments';

const AppName = 'tracking-page';

const DevelopmentClientToken = 'pub2d7a4d394f4298e3fd1c46fe9ede8388';
const ProductionClientToken = 'pubc13843e8aa0386ce1d3b58ce23ad22b4';

function getClientToken() {
  switch (getEnvironmentLabel()) {
    case environmentLabels.Prod:
      return ProductionClientToken;
    case environmentLabels.Int:
    case environmentLabels.Qa:
    case environmentLabels.Perf:
      return DevelopmentClientToken;
    default:
      return null;
  }
}

export default function initDatadog() {
  const clientToken = getClientToken();
  if (!clientToken) {
    return;
  }

  datadogLogs.init({
    clientToken: getClientToken(),
    site: 'datadoghq.com',
    service: AppName,
    env: getEnvironmentLabel(),
    forwardErrorsToLogs: true,
    sampleRate: 100,
    version: process.env.REACT_APP_CODE_VERSION,
  });
  const logTraceId = Math.trunc(Math.random() * 1000000000000000).toString(36)
    + new Date().getTime().toString(36);
  datadogLogs.addLoggerGlobalContext('LogTraceId', `TP_${logTraceId}`);
}
